export interface LanguageMessage {
  enabled: boolean;
  message: string;
}

export interface LocationReviewRequestPrintsSizeOptions {
  messages: {
    [languageCode: string]: LanguageMessage;
  };
}

export interface LocationReviewRequestPrintsData {
  id: bigint;
  location_id: bigint;
  card_size_options: LocationReviewRequestPrintsSizeOptions;
  a_four_size_options: LocationReviewRequestPrintsSizeOptions;
  a_five_size_options: LocationReviewRequestPrintsSizeOptions;
  created_at: string;
  updated_at: string;
}

// DTO for PATCH request - uses enabled_languages array
export interface UpdateLocationReviewRequestPrintsSizeOptionsDTO {
  enabled_languages: string[];
}

export interface UpdateLocationReviewRequestPrintsDTO {
  card_size_options?: UpdateLocationReviewRequestPrintsSizeOptionsDTO;
  a_four_size_options?: UpdateLocationReviewRequestPrintsSizeOptionsDTO;
  a_five_size_options?: UpdateLocationReviewRequestPrintsSizeOptionsDTO;
}

export type PrintSize = "card" | "a5" | "a4";

export interface PrintDimensions {
  width: number;
  height: number;
  unit: "mm";
}

export const PRINT_DIMENSIONS: Record<PrintSize, PrintDimensions> = {
  card: { width: 91, height: 55, unit: "mm" },
  a5: { width: 210, height: 148, unit: "mm" },
  a4: { width: 297, height: 210, unit: "mm" },
};

export const AVAILABLE_LANGUAGES = [
  { code: "en", label: "English" },
  { code: "ja", label: "日本語" },
  { code: "zh", label: "中文" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "it", label: "Italiano" },
  { code: "pt", label: "Português" },
  { code: "ru", label: "Русский" },
  { code: "ko", label: "한국어" },
  { code: "ar", label: "العربية" },
  { code: "hi", label: "हिन्दी" },
  { code: "th", label: "ภาษาไทย" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "ms", label: "Bahasa Melayu" },
  { code: "nl", label: "Nederlands" },
  { code: "sv", label: "Svenska" },
  { code: "no", label: "Norsk" },
  { code: "da", label: "Dansk" },
  { code: "fi", label: "Suomi" },
  { code: "pl", label: "Polski" },
  { code: "tr", label: "Türkçe" },
  { code: "el", label: "Ελληνικά" },
  { code: "he", label: "עברית" },
];
